import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bf38af2&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0bf38af2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf38af2",
  null
  
)

export default component.exports